import DOMPurify from "dompurify";
import { RichText } from "@/components/site/PageShell";

const isHtml = (s) => /<\/?(p|h2|h3|ul|ol|li|img|a|strong|em|blockquote|br)\b/i.test(s || "");

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && /^https?:\/\//i.test(node.getAttribute("href") || "") && !node.getAttribute("href").includes(window.location.host)) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
  if (node.tagName === "IMG") {
    node.setAttribute("loading", "lazy");
    const src = node.getAttribute("src") || "";
    if (src.startsWith("/api/")) node.setAttribute("src", `${process.env.REACT_APP_BACKEND_URL}${src}`);
  }
});

export const ArticleBody = ({ content }) =>
  isHtml(content) ? (
    <div data-testid="article-body" className="prose-bp" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, { ADD_ATTR: ["target"] }) }} />
  ) : (
    <RichText text={content} />
  );

export const readingTime = (content) => {
  const words = (content || "").replace(/<[^>]+>/g, " ").split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
};
